import React, { FC, useEffect, useState } from "react";
import { Toggle as _Toggle } from "rsuite";

import "./index.scss";

export type ToggleProps = {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: () => void;
};

export const Toggle: FC<ToggleProps> = ({ checked, onChange, defaultChecked = false }) => {
  return (
    <span className="toggle-component">
      <_Toggle size="lg" checked={checked} defaultChecked={defaultChecked} onChange={onChange} />
    </span>
  );
};

export const useToggle = ({ defaultChecked = false }: Partial<ToggleProps>): [boolean, () => void] => {
  const [visible, setVisible] = useState(() => defaultChecked);

  useEffect(() => {
    setVisible(defaultChecked);
  }, [defaultChecked]);

  const handleToggle = () => setVisible((prevState) => !prevState);

  return [visible, handleToggle];
};
